// import React from 'react'

// const WhatsAppTerms = () => {
//   return (
//     <div>
//       whats app terms
//     </div>
//   )
// }

// export default WhatsAppTerms

// import React from 'react';
// import { Link } from 'react-router-dom';
// import term from "../../assets/footerimage/termcondition.png";

// import hero from "../../assets/footerimage/Term-&-Conditions.png";

// const WhatsAppTerms = () => {
//   const today = new Date().toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'long',
//     day: 'numeric'
//   });

//   return (
//     <div className="relative min-h-screen">
//       {/* Hero Section */}
//       <div className="relative h-[300px] md:h-[400px] overflow-hidden">
//         <img src={hero} alt="" className="h-full w-full object-cover" />
//         <div className="absolute inset-0 bg-black opacity-50"></div>
//         <div className="relative z-10 flex flex-col justify-center items-end h-full px-6 md:px-16 text-white">
//           <div className="flex items-center space-x-2 text-sm md:text-base">
//             <Link to="/" className="text-white hover:underline font-bold">
//               Home
//             </Link>
//             <span className="text-red-500">●</span>
//             <span className="text-orange-400"> Terms and Conditions</span>
//           </div>
//         </div>
//       </div>

//       {/* Terms Content */}
//       <div className="max-w-6xl mx-auto px-4 py-8 md:py-12 text-gray-800">
//         <h2 className="text-2xl sm:text-3xl font-semibold text-orange-600 mb-2 md:mb-2">
//           Terms and Conditions
//         </h2>
//         <div className="w-full h-[2px] bg-orange-600 rounded mt-3 mb-6" />

//         <div className="mb-6 text-sm text-gray-600">
//           <p>Last Updated: {today}</p>
//         </div>

//         {/* Section 1: Introduction */}
//         <div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8 rounded-lg mb-8">
//           {/* Text Left */}
//           <div className="w-full md:w-1/2">
//             <h2 className="text-xl md:text-2xl font-semibold mb-4 text-blue-700">
//               1. Introduction
//             </h2>
//             <p className="text-sm md:text-base leading-relaxed">
//               Welcome to [Your Company Name] ("Platform", "we", "us", "our").
//               These Terms & Conditions ("Terms") govern your access and use of our
//               WhatsApp Business Messaging Platform, including all features such as:
//             </p>
//             <ul className="list-disc pl-5 mt-2 text-sm md:text-base">
//               <li>Template creation & management</li>
//               <li>Sending WhatsApp messages</li>
//               <li>Business conversation management</li>
//               <li>Analytics and reporting</li>
//               <li>Facebook/Meta login integration</li>
//             </ul>
//             <p className="text-sm md:text-base leading-relaxed mt-2">
//               By creating an account or connecting your Facebook/WhatsApp Business
//               Account, you agree to these Terms. If you do not agree, please do not
//               use the Platform.
//             </p>
//           </div>

//           {/* Image Right */}
//           <div className="w-full md:w-1/2">
//             <img
//               src={term}
//               alt="Terms and Conditions"
//               className="w-full h-auto max-h-[400px] object-contain rounded-lg shadow"
//             />
//           </div>
//         </div>

//         {/* Section 2: Meta Login Permissions */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             2. Meta Login Permissions
//           </h2>
//           <p className="md:text-base text-sm">
//             To enable WhatsApp Business API features, our Platform requires you to login using Facebook.
//             When you connect your account, you authorize us to access:
//           </p>
//           <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
//             <li>Your public profile (name, email)</li>
//             <li>Your Business Manager account</li>
//             <li>Your WhatsApp Business Accounts (WABA)</li>
//             <li>Your WABA phone numbers</li>
//             <li>Your WhatsApp message templates</li>
//           </ul>
//           <p className="md:text-base text-sm mt-3">
//             We do NOT access:
//           </p>
//           <ul className="list-disc pl-5 mt-1 md:text-base text-sm">
//             <li>Your personal Facebook content</li>
//             <li>Private WhatsApp messages</li>
//             <li>Instagram content</li>
//             <li>Friend lists</li>
//             <li>Personal posts or photos</li>
//           </ul>
//           <p className="md:text-base text-sm mt-3">
//             We also never post anything on your behalf. This access is required only to enable business WhatsApp services.
//           </p>
//         </div>

//         {/* Section 3: Use of Service */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             3. Use of Service
//           </h2>
//           <p className="md:text-base text-sm">
//             You agree to use the Platform only for lawful business purposes. You must not:
//           </p>
//           <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
//             <li>Use WhatsApp for spam or unsolicited messages</li>
//             <li>Violate Meta's Commerce or Messaging Policies</li>
//             <li>Send illegal, harmful, abusive, or misleading content</li>
//             <li>Attempt to bypass Meta's approval process</li>
//             <li>Share your login credentials with unauthorized users</li>
//           </ul>
//           <p className="md:text-base text-sm mt-3">
//             Violation may result in suspension or termination.
//           </p>
//         </div>

//         {/* Section 4: WhatsApp Template Usage */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             4. WhatsApp Template Usage
//           </h2>
//           <p className="md:text-base text-sm">
//             All message templates must:
//           </p>
//           <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
//             <li>Be created via the Platform</li>
//             <li>Follow Meta's Template Guidelines</li>
//             <li>Be approved by Meta before sending</li>
//             <li>Not contain harmful, fraudulent, or deceptive content</li>
//           </ul>
//           <p className="md:text-base text-sm mt-3">
//             You are fully responsible for the content you submit.
//           </p>
//         </div>

//         {/* Section 5: Data Collection & Usage */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             5. Data Collection & Usage
//           </h2>
//           <p className="md:text-base text-sm">
//             We collect only the data required to operate the Platform:
//           </p>
//           <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
//             <li>Business profile information</li>
//             <li>WhatsApp Business Account details</li>
//             <li>Phone numbers assigned to your WABA</li>
//             <li>Template metadata</li>
//             <li>Message logs & analytics</li>
//           </ul>
//           <p className="md:text-base text-sm mt-3">
//             We do not store personal WhatsApp chat content. Your data is encrypted and used strictly to provide the service.
//           </p>
//         </div>

//         {/* Section 6: Data Privacy & Protection */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             6. Data Privacy & Protection
//           </h2>
//           <p className="md:text-base text-sm">
//             We follow industry-standard security practices including:
//           </p>
//           <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
//             <li>Encrypted API communication</li>
//             <li>Secure token storage</li>
//             <li>No sharing of your data with third parties</li>
//           </ul>
//           <p className="md:text-base text-sm mt-3">
//             You retain full ownership of your data. For complete details, please refer to our Privacy Policy.
//           </p>
//         </div>

//         {/* Section 7: Billing & Charges */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             7. Billing & Charges
//           </h2>
//           <p className="md:text-base text-sm">
//             If you choose paid features, you agree to pay all applicable charges.
//             WhatsApp conversation charges are billed as per Meta's official pricing, not ours.
//             Refunds are processed case-by-case.
//           </p>
//         </div>

//         {/* Section 8: Account Termination */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             8. Account Termination
//           </h2>
//           <p className="md:text-base text-sm">
//             We may suspend or terminate your access if you:
//           </p>
//           <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
//             <li>Violate Meta's policies</li>
//             <li>Violate these Terms</li>
//             <li>Use WhatsApp for harmful content</li>
//             <li>Abuse the platform</li>
//           </ul>
//           <p className="md:text-base text-sm mt-3">
//             You may also request account deletion at any time.
//           </p>
//         </div>

//         {/* Section 9: Limitation of Liability */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             9. Limitation of Liability
//           </h2>
//           <p className="md:text-base text-sm">
//             We are not responsible for:
//           </p>
//           <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
//             <li>WhatsApp downtime or API failures</li>
//             <li>Meta policy changes or restrictions</li>
//             <li>Loss of business due to WhatsApp delivery delays</li>
//             <li>User misuse or unauthorized access</li>
//           </ul>
//           <p className="md:text-base text-sm mt-3">
//             Our platform operates as a tool; the responsibility of message content remains with the business owner.
//           </p>
//         </div>

//         {/* Section 10: Changes to Terms */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             10. Changes to Terms
//           </h2>
//           <p className="md:text-base text-sm">
//             We may update these Terms at any time. Continued use of the Platform means you accept the updated Terms.
//           </p>
//         </div>

//         {/* Section 11: Contact Information */}
//         <div className="mb-6">
//           <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
//             11. Contact Information
//           </h2>
//           <p className="md:text-base text-sm">
//             For any questions, feel free to contact us:
//           </p>
//           <ul className="list-none pl-0 mt-2 md:text-base text-sm">
//             <li className="mb-1">📧 Email: support@[yourdomain].com</li>
//             <li className="mb-1">🌐 Website: https://yourdomain.com</li>
//             <li className="mb-1">📞 Phone: [your phone number]</li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WhatsAppTerms;

import React from "react";
// import { Link } from "react-router-dom";
import term from "../../assets/footerimage/termcondition.png";

const TermsAndConditions = () => {
  return (
    <div className="relative min-h-screen">
      {/* Terms Content */}
      <div className="max-w-6xl mx-auto px-4 py-8 md:py-12 text-gray-800">
        <h2 className="text-2xl sm:text-3xl font-semibold text-orange-600 mb-2 md:mb-2">
          WhatsApp Terms and Conditions
        </h2>
        <div className="w-full h-[2px] bg-orange-600 rounded mt-3 mb-6" />

        {/* Section 1: Introduction */}
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8 rounded-lg mb-8">
          {/* Text Left */}
          <div className="w-full md:w-1/2">
            <h2 className="text-xl md:text-2xl font-semibold mb-4 text-blue-600">
              1. Introduction
            </h2>
            <p className="text-sm md:text-base leading-relaxed">
              Welcome to <strong> DeetyaSoft Pvt. Ltd. </strong> ("Platform",
              "we", "us", "our"). These Terms & Conditions ("Terms") govern your
              access and use of our WhatsApp Business Messaging Platform,
              including all features such as:
            </p>
            <ul className="list-disc pl-5 mt-2 text-sm md:text-base">
              <li>Template creation & management</li>
              <li>Sending WhatsApp messages</li>
              <li>Business conversation management</li>
              <li>Analytics and reporting</li>
              <li>Facebook/Meta login integration</li>
            </ul>
            <p className="text-sm md:text-base leading-relaxed mt-2">
              By creating an account or connecting your Facebook/WhatsApp
              Business Account, you agree to these Terms. If you do not agree,
              please do not use the Platform.
            </p>
          </div>

          {/* Image Right */}
          <div className="w-full md:w-1/2">
            <img
              src={term}
              alt="Terms and Conditions"
              className="w-full h-auto max-h-[400px] object-contain rounded-lg shadow"
            />
          </div>
        </div>

        {/* Section 2: Meta Login Permissions */}
        <div className="mb-6">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            2. Meta Login Permissions
          </h2>
          <p className="md:text-base text-sm">
            To enable WhatsApp Business API features, our Platform requires you
            to login using Facebook. When you connect your account, you
            authorize us to access:
          </p>
          <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
            <li>Your public profile (name, email)</li>
            <li>Your Business Manager account</li>
            <li>Your WhatsApp Business Accounts (WABA)</li>
            <li>Your WABA phone numbers</li>
            <li>Your WhatsApp message templates</li>
          </ul>
          <p className="md:text-base  font-bold text-red-500 text-sm mt-3">
            We do NOT access:
          </p>
          <ul className="list-disc pl-5 mt-1 md:text-base text-sm">
            <li>Your personal Facebook content</li>
            <li>Private WhatsApp messages</li>
            <li>Instagram content</li>
            <li>Friend lists</li>
            <li>Personal posts or photos</li>
          </ul>
          <p className="md:text-base text-sm mt-3">
            We also never post anything on your behalf. This access is required
            only to enable business WhatsApp services.
          </p>
        </div>

        {/* Section 3: Use of Service */}
        <div className="mb-6">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            3. Use of Service
          </h2>
          <p className="md:text-base text-sm">
            You agree to use the Platform only for lawful business purposes. You
            must not:
          </p>
          <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
            <li>Use WhatsApp for spam or unsolicited messages</li>
            <li>Violate Meta's Commerce or Messaging Policies</li>
            <li>Send illegal, harmful, abusive, or misleading content</li>
            <li>Attempt to bypass Meta's approval process</li>
            <li>Share your login credentials with unauthorized users</li>
          </ul>
          <p className="md:text-base text-sm mt-3">
            Violation may result in suspension or termination.
          </p>
        </div>

        {/* Section 4: WhatsApp Template Usage */}
        <div className="mb-6">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            4. WhatsApp Template Usage
          </h2>
          <p className="md:text-base text-sm">All message templates must:</p>
          <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
            <li>Be created via the Platform</li>
            <li>Follow Meta's Template Guidelines</li>
            <li>Be approved by Meta before sending</li>
            <li>Not contain harmful, fraudulent, or deceptive content</li>
          </ul>
          <p className="md:text-base text-sm mt-3">
            You are fully responsible for the content you submit.
          </p>
        </div>

        {/* Section 5: Data Collection & Usage */}
        <div className="mb-6">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            5. Data Collection & Usage
          </h2>
          <p className="md:text-base text-sm">
            We collect only the data required to operate the Platform:
          </p>
          <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
            <li>Business profile information</li>
            <li>WhatsApp Business Account details</li>
            <li>Phone numbers assigned to your WABA</li>
            <li>Template metadata</li>
            <li>Message logs & analytics</li>
          </ul>
          <p className="md:text-base text-sm mt-3">
            We do not store personal WhatsApp chat content. Your data is
            encrypted and used strictly to provide the service.
          </p>
        </div>

        {/* Section 6: Data Privacy & Protection */}
        <div className="mb-6">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            6. Data Privacy & Protection
          </h2>
          <p className="md:text-base text-sm">
            We follow industry-standard security practices including:
          </p>
          <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
            <li>Encrypted API communication</li>
            <li>Secure token storage</li>
            <li>No sharing of your data with third parties</li>
          </ul>
          <p className="md:text-base text-sm mt-3">
            You retain full ownership of your data. For complete details, please
            refer to our Privacy Policy.
          </p>
        </div>

        {/* Section 7: Billing & Charges */}
        <div className="mb-6">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            7. Billing & Charges
          </h2>
          <p className="md:text-base text-sm">
            If you choose paid features, you agree to pay all applicable
            charges. WhatsApp conversation charges are billed as per Meta's
            official pricing, not ours. Refunds are processed case-by-case.
          </p>
        </div>

        {/* Section 8: Account Termination */}
        <div className="mb-6">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            8. Account Termination
          </h2>
          <p className="md:text-base text-sm">
            We may suspend or terminate your access if you:
          </p>
          <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
            <li>Violate Meta's policies</li>
            <li>Violate these Terms</li>
            <li>Use WhatsApp for harmful content</li>
            <li>Abuse the platform</li>
          </ul>
          <p className="md:text-base text-sm mt-3">
            You may also request account deletion at any time.
          </p>
        </div>

        {/* Section 9: Limitation of Liability */}
        <div className="mb-6">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            9. Limitation of Liability
          </h2>
          <p className="md:text-base text-sm">We are not responsible for:</p>
          <ul className="list-disc pl-5 mt-2 md:text-base text-sm">
            <li>WhatsApp downtime or API failures</li>
            <li>Meta policy changes or restrictions</li>
            <li>Loss of business due to WhatsApp delivery delays</li>
            <li>User misuse or unauthorized access</li>
          </ul>
          <p className="md:text-base text-sm mt-3">
            Our platform operates as a tool; the responsibility of message
            content remains with the business owner.
          </p>
        </div>

        {/* Section 10: Changes to Terms */}
        <div className="mb-6">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            10. Changes to Terms
          </h2>
          <p className="md:text-base text-sm">
            We may update these Terms at any time. Continued use of the Platform
            means you accept the updated Terms.
          </p>
        </div>

        {/* Section 11: Contact Information */}

        <div className="mb-6 bg-gray-50 rounded-lg">
          <h2 className="md:text-xl text-blue-700 text-lg font-semibold mb-3">
            11. Contact Information
          </h2>

          <p className="md:text-base text-sm mb-4">
            For any questions, feel free to contact us:
          </p>

          <div className="grid grid-cols-1 gap-2">
            {/* Email */}
            <div className="flex items-start space-x-2">
              <span className="text-blue-600 mt-1">📧</span>
              <div>
                <p className="font-medium text-gray-800">Email:</p>
                <a
                  href="mailto:info@deetyasoft.com"
                  className="text-blue-600 hover:underline"
                >
                  info@deetyasoft.com
                </a>
              </div>
            </div>

            {/* Website */}
            <div className="flex items-start space-x-2">
              <span className="text-blue-600 mt-1">🌐</span>
              <div>
                <p className="font-medium text-gray-800">Website:</p>
                <a
                  href="https://deetyasoft.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  https://deetyasoft.com
                </a>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-start space-x-2">
              <span className="text-blue-600 mt-1">📞</span>
              <div>
                <p className="font-medium text-gray-800">Phone:</p>
                <a
                  href="tel:+919015350505"
                  className="text-blue-600 hover:underline"
                >
                  +91-9015350505
                </a>
              </div>
            </div>
          </div>

          <div className="mt-3 border-gray-200">
            <p className="text-sm text-gray-600">
              <strong>Company Name:</strong> DeetyaSoft Pvt. Ltd.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
